import React, { Component } from "react";

import { Table, Card, Row, Col, Form, Image } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import ChemistPaymentView from "../ChemistPayment/ChemistPaymentView";
import ChemistPaymentStatusChange from "../ChemistPayment/ChemistPaymentStatusChange";

import "../../Common/Common.css";
var dateFormat = require("dateformat");

class ChemistPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ChemistPaymentShow: false,
      showChemistPaymentActive: false,
      page: 0,
      perPage: 10,
      searchChemistPayment: "",
      filterValue: "",
    };
  }

  componentDidMount() {
    this.props.chemistPaymentList({
      page: undefined,
      search: this.state.searchChemistPayment,
      filter: this.state.filterValue,
    });
  }

  handleChemistPaymentView = (item) => {
    this.setState({
      ChemistPaymentShow: true,
      ChemistPaymentDtls: item,
    });
  };

  handleCloseChemistPaymentView = () => {
    this.setState({ ChemistPaymentShow: false });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.ChemistPaymentSelectedPage({
      page: selectedPage + 1,
      search: this.state.searchChemistPayment,
      filter: this.state.filterValue,
    });
    this.setState({ page: selectedPage });
  };
  resetPage = () => {
    this.setState({ page: 0 });
  };

  handleChemistPaymentActiveView = (item) => {
    this.setState({
      showChemistPaymentActive: true,
      ChemistPaymentActiveDtls: item,
    });
  };
  handleCloseActive = () => {
    this.setState({ showChemistPaymentActive: false });
  };

  SearchOnChange = (event) => {
    this.setState(
      {
        searchChemistPayment: event.target.value,
        page: 0,
      },
      () => {
        this.props.chemistPaymentList({
          page: undefined,
          search: this.state.searchChemistPayment,
          filter: this.state.filterValue,
        });
      }
    );
  };

  handleChange = (event) => {
    this.setState(
      {
        filterValue: event.target.value,
        page: 0,
      },
      () => {
        this.props.chemistPaymentList({
          page: undefined,
          search: this.state.searchChemistPayment,
          filter: this.state.filterValue,
        });
      }
    );
  };

  render() {
    let p = this.state.page + 1;
    const count =
      this.props.chemistPaymentDtlsCount && this.props.chemistPaymentDtlsCount;
    let ChemistPaymentPageCount = Math.ceil(count / this.state.perPage);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={12} md={3} lg={3}>
                <h3>Chemist Payments</h3>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonFilterDiv">
                  <select
                    value={this.state.filterValue}
                    onChange={this.handleChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    <option value="open">Open</option>
                    {/* <option value="partial">Partial</option> */}
                    <option value="paid">Paid</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon" />
                    <input
                      type="text"
                      placeholder="Reference No/ Order ID"
                      onChange={this.SearchOnChange}
                      value={this.state.searchChemistPayment}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonRecrd">
                  <i className="cui-note icons cmnRecordIcon" />
                  <span className="cmnPageCount">
                    {count === undefined ? 0 : count}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Table responsive bordered striped className="cmnMainTable">
                <thead>
                  <tr className="cmnMainTableHd">
                    <th>SL NO</th>
                    <th>REFERENCE NO</th>
                    <th>ORDER ID</th>
                    <th>DISTRIBUTOR</th>
                    <th>CHEMIST</th>
                    <th>CREATED DATE</th>
                    <th>AMOUNT</th>
                    <th>STATUS</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.chemistPaymentDtlsList &&
                    this.props.chemistPaymentDtlsList.map((item, i) => (
                      <tr key={i}>
                        <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap">{item.invNo}</td>
                        <td className="cmn_Cap">
                          {item.orderId && item.orderId.orderNo}
                        </td>
                        <td className="cmn_Cap">
                          {item.recptDtls && item.recptDtls.name}
                        </td>
                        <td className="cmn_Cap">
                          {item.userCmstDtls && item.userCmstDtls.name}
                        </td>
                        <td className="cmn_Cap">
                          {dateFormat(item.createdAt, "mediumDate")}
                        </td>
                        <td className="rightAlign">{item.paidAmnt}</td>
                        <td className="cmn_Cap">{item.status}</td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() =>
                                this.handleChemistPaymentView({ item: item })
                              }
                            />

                            <i
                              className="fa fa-ban fa-lg"
                              style={{ paddingLeft: 10 }}
                              onClick={() =>
                                this.handleChemistPaymentActiveView({
                                  item: item,
                                })
                              }
                            />
                             <ChemistPaymentStatusChange
                              show={this.state.showChemistPaymentActive}
                              handleClose={this.handleCloseActive}
                              ChemistPaymentActiveDtls={
                                this.state.ChemistPaymentActiveDtls
                              }
                              refreshParams={{
                                page: 1,
                                search: this.state.searchChemistPayment,
                                filter: this.state.filterValue
                              }}
                              ChemistPaymentStatusChange={
                                this.props.ChemistPaymentStatusChange
                              }
                              resetPage={this.resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              <ChemistPaymentView
                show={this.state.ChemistPaymentShow}
                handleClose={this.handleCloseChemistPaymentView}
                ChemistPaymentDtls={this.state.ChemistPaymentDtls}
              />

              {(this.props.chemistPaymentDtlsList === undefined ||
                (this.props.chemistPaymentDtlsList &&
                  this.props.chemistPaymentDtlsList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../../src/assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Payments Found</div>
                </div>
              )}
            </div>
          </Card.Body>

          {ChemistPaymentPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={ChemistPaymentPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}
export default ChemistPayment;
